var map = {
	"./activity.svg": "+5Yu",
	"./arrow-left.svg": "Cbmn",
	"./asc.svg": "/xYH",
	"./calendar.svg": "rM+T",
	"./cancel-job.svg": "PAAE",
	"./code-editor.svg": "VBia",
	"./column-alignment/center-blue.svg": "Yd4W",
	"./column-alignment/center.svg": "6J2j",
	"./column-alignment/left-blue.svg": "qAKv",
	"./column-alignment/left.svg": "Hu+Y",
	"./column-alignment/right-blue.svg": "Wlcp",
	"./column-alignment/right.svg": "ryXo",
	"./column-type/action_button.svg": "at5U",
	"./column-type/attachment.svg": "teWD",
	"./column-type/currency.svg": "ZGMJ",
	"./column-type/currency_selection.svg": "Exmu",
	"./column-type/date.svg": "Lhj1",
	"./column-type/datetime.svg": "nQL3",
	"./column-type/multiple_attachment.svg": "Y5bH",
	"./column-type/multiple_text.svg": "uqKo",
	"./column-type/number.svg": "+7pR",
	"./column-type/person.svg": "Wsai",
	"./column-type/progress_bar.svg": "1x1q",
	"./column-type/text.svg": "iHvK",
	"./column-type/time.svg": "NB3L",
	"./confirmation.svg": "O5qO",
	"./copy.svg": "HfAc",
	"./desc.svg": "CPss",
	"./export-data-white.svg": "uxCK",
	"./eye-close.svg": "EI60",
	"./file-csv.svg": "2OF4",
	"./file-doc.svg": "mJq2",
	"./file-folder.svg": "30bm",
	"./file-image.svg": "YHo5",
	"./file-music.svg": "lY1R",
	"./file-pdf.svg": "UV3t",
	"./file-ppt.svg": "uMg1",
	"./file-txt.svg": "HtK/",
	"./file-xls.svg": "8VDL",
	"./file-zip.svg": "/HgX",
	"./filter.svg": "mjby",
	"./foldering/delete.svg": "XsxE",
	"./foldering/detail.svg": "tdqO",
	"./foldering/download.svg": "1KXg",
	"./foldering/move.svg": "wd9v",
	"./foldering/open.svg": "e+JI",
	"./foldering/rename.svg": "jdFf",
	"./forum.svg": "pT4p",
	"./fullscreen.svg": "JR7s",
	"./help-blue.svg": "i1fG",
	"./help-gray.svg": "kZcT",
	"./help.svg": "L7An",
	"./icon-close-properties.svg": "JCwt",
	"./info-circle.svg": "oaOb",
	"./info.svg": "IUKX",
	"./joana.svg": "D/ca",
	"./laptop.svg": "o0ok",
	"./level-application.svg": "BubL",
	"./level-page.svg": "fx9Y",
	"./list-document.svg": "WQjV",
	"./login.svg": "bSwZ",
	"./menu.svg": "WMM8",
	"./minimize.svg": "KzE5",
	"./monitor.svg": "NOAu",
	"./move-table.svg": "pexz",
	"./pencil-edit.svg": "qZlM",
	"./phone.svg": "1ldQ",
	"./query/delete.svg": "dsBx",
	"./query/edit.svg": "RIVN",
	"./query/merge-data-off.svg": "dTCb",
	"./query/merge-data-on.svg": "Y89U",
	"./query/open.svg": "b1lA",
	"./query/query-saved.svg": "uVRR",
	"./query/radio-off.svg": "xQwY",
	"./query/radio-on.svg": "okwb",
	"./query/replace-data-off.svg": "INWa",
	"./query/replace-data-on.svg": "EqZv",
	"./query/run.svg": "wJlt",
	"./query/save.svg": "LLX5",
	"./refresh.svg": "WnjX",
	"./retry-job.svg": "d9/9",
	"./retry.svg": "OSVo",
	"./rotate.svg": "ajOO",
	"./run-history.svg": "hzud",
	"./search-page.svg": "y5DE",
	"./setting.svg": "2yne",
	"./shortcut-page/add-shortcut.svg": "s6r6",
	"./shortcut-page/add.svg": "6/CA",
	"./shortcut-page/grid-blue.svg": "TAQy",
	"./shortcut-page/grid.svg": "wzjV",
	"./shortcut-page/list-blue.svg": "yfwr",
	"./shortcut-page/list.svg": "UHjN",
	"./style-attachment-grid-active.svg": "dvp0",
	"./style-attachment-grid.svg": "geNm",
	"./style-attachment-list-active.svg": "bcd9",
	"./style-attachment-list.svg": "7Bcl",
	"./toast/error.svg": "Ua7H",
	"./toast/info.svg": "nWSt",
	"./toast/success.svg": "8Obw",
	"./toast/warning.svg": "lQpv",
	"./unknown-device.svg": "8HNf",
	"./warning.svg": "1hzb",
	"./xmark.svg": "7tb7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ySkN";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon ^\.\/.*\.svg$
// module id = ySkN
// module chunks = 46